<template>
  <import-contacts />
</template>

<script>
import ImportContacts from "@/components/3pl/CRM/CustomerRegistration/ImportContacts";
export default {
  components: {
    ImportContacts,
  },
};
</script>

<style></style>
